<script setup lang="ts">
    import User from '~~/app/auth/models/User';

    interface Props {
        users: Array<User>;
        negativeMargin?: string;
        size?: string;
        borderColor?: string;
        borderSize?: string;
        placeholderAvatarColor?: string;
        clickableAvatar?: boolean;
    }
    const props = withDefaults(defineProps<Props>(), {
        negativeMargin: '-ml-4',
        size: 'w-[34px] h-[34px]',
        borderColor: '',
        borderSize: '',
        // No colour of its own: the avatar paints its own background, either the image or the
        // user's configured colour. A backdrop here would show through and make every user look alike.
        placeholderAvatarColor: '',
        clickableAvatar: true,
    });
</script>

<template>
    <div class="flex items-center space-x-[-6px]">
        <div
            v-for="user in users"
            :key="user?.getInternalId()"
        >
            <div :class="`${size} ${borderSize} ${borderColor} rounded-full cursor-pointer ${placeholderAvatarColor}`">
                <figure class="w-full h-full">
                    <AuthUserAvatar
                        :user="user"
                        :size="size"
                        :clickable-avatar="clickableAvatar"
                    />
                </figure>
            </div>
        </div>
    </div>
</template>
